import React from "react";
import {Config} from '../Config';
import * as Utils from '../inc/Utils';
import {NavLink, useNavigate, useParams} from "react-router-dom";
import toast, {Toaster} from "react-hot-toast";
import moment from "moment-timezone";
import MemberSidebar from "../inc/MemberSidebar";
import {confirmAlert} from "react-confirm-alert";
import 'react-confirm-alert/src/react-confirm-alert.css';
import ProposalTargetUser from "./ProposalTargetUser";
import ProposalTargetBenefit from "./ProposalTargetBenefit";
import ProposalProcess from "./ProposalProcess";
import ProposalImpact from "./ProposalImpact";
import ProposalExpect from "./ProposalExpect";

export default function ProposalOutput(prop) {
    let navigate = useNavigate();
    let {encode} = useParams();
    let decode = Utils.decodeItem(encode);
    let proposalId = decode.proposalId;
    let isReadOnly = decode.readOnly;

    let member = prop.member;
    let [detail, setDetail] = React.useState(null);
    let [benefitId, setBenefitId] = React.useState(1);
    let [benefitSubId, setBenefitSubId] = React.useState(1);
    let [readOnly, setReadOnly] = React.useState(false);

    let refBenefitDetail = React.useRef();
    let refBeneficiary = React.useRef();

    React.useEffect(() => {
        //window.scrollTo(0, 0);

        (async function() {
            try {
                const resDetail = await getDetail();
                if(resDetail) {
                    setDetail(resDetail);

                    if ([Utils.PROPOSAL_STATUS_APPROVE].includes(resDetail.status)) {
                        setReadOnly(true);
                    }

                    if(isReadOnly) {
                        setReadOnly(isReadOnly);
                    }

                    if (prop !== null && prop.lang === 'en') {
                        resDetail.title = resDetail.title_en;
                    }
                }

                const resData = await getData();
                if(resData) {
                    refBenefitDetail.current.value = resData.benefitDetail;
                    refBeneficiary.current.value = resData.beneficiary;
                    setBenefitId(resData.benefit);
                    setBenefitSubId(resData.benefitSub);
                }

                document.title = 'ทุนวิจัย Scholarship | NCSA - ' + resDetail.title;
            } catch (e) {
                //
            }
        })();
    }, []);

    async function getDetail() {
        const response = await fetch(Config.apiUrl +'/proposal/viewProposal', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': member.accessToken
            },
            body: JSON.stringify({
                id: proposalId
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function getData() {
        const response = await fetch(Config.apiUrl +'/proposalOutput/viewInfo', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': member.accessToken
            },
            body: JSON.stringify({
                proposalId: proposalId
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    const onCancel = () => {
        //if(readOnly) {
        //    navigate((prop.lang === 'en' ? '/en':'') + '/proposalApprove');
        //}
        //else {
        navigate((prop.lang === 'en' ? '/en':'') + '/proposal');
        //}
    };

    const onSubmit = async () => {
        let benefitDetail = refBenefitDetail.current.value;
        let beneficiary = refBeneficiary.current.value;

        if(benefitDetail === '') {
            toast.error(prop.lang === 'en' ? 'Please specify Expected benefits':'กรุณาระบุ รายละเอียดประโยชน์ที่คาดว่าจะได้รับ');
            refBenefitDetail.current.focus();
        }
        else if(beneficiary === '') {
            toast.error(prop.lang === 'en' ? 'Please specify Beneficiaries of the project':'ผู้ได้รับประโยชน์จากโครงการ');
            refBeneficiary.current.focus();
        }
        else {
            confirmAlert({
                title: 'แจ้งเตือน',
                message: 'ต้องการบันทึกข้อมูล ?',
                buttons: [
                    {
                        label: 'ตกลง',
                        onClick: async () => {
                            let param = {
                                proposalId: proposalId,
                                benefitDetail: benefitDetail.trim(),
                                beneficiary: beneficiary.trim(),
                                benefit: benefitId,
                                benefitSub: benefitId === Utils.PROPOSAL_OUTPUT_SOCIAL ? benefitSubId : null,
                                updatedBy: -1,
                                updatedAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss')
                            };
                            const result = await updateInfo(param);

                            if(result.status === 'success') {
                                toast.success(prop.lang === 'en' ? 'Part 2 Research project information has been recorded successfully.':'อัพเดตข้อมูล ผลผลิต/ผลลัพธ์/ผลกระทบ เรียบร้อย');
                            }
                            else {
                                toast.error(prop.lang === 'en' ? 'Sorry, there is a problem. Please contact the administrator':'ขออภัยมีเหตุขัดข้อง กรุณาติดต่อผู้่ดูแลระบบ');
                            }
                        }
                    },
                    {
                        label: 'ยกเลิก',
                        onClick: () => {}
                    }
                ]
            });
        }
    };

    async function updateInfo(param) {
        const response = await fetch(Config.apiUrl +'/proposalOutput/update', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': member.accessToken
            },
            body: JSON.stringify(param)
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    return (
        <>
            <div className="section">
                <div className="container has-sidebar">
                    <div className="sidebar">
                        <MemberSidebar active="proposal" lang={prop.lang} />
                    </div>
                    <div className="content">
                        <div className="card-infos has-shadow-black" data-aos="fade-in">
                            <div className="card-body p-0 px-xxl-3">
                                <h2 className="h3 text-center">{prop.lang === 'en' ? 'Full Proposal':'ยื่นแบบฟอร์มข้อเสนอโครงการฉบับสมบูรณ์ (Full Proposal)'}</h2>
                                <div className="text-center">{prop.lang === 'en' ? 'Strategic Research Project (Strategic Fund; SF): Research Project Type':'โครงการวิจัยเชิงกลยุทธ์ (Strategic Fund; SF) : ประเภทโครงการวิจัย'}</div>
                                <h3 className="mt-2 text-center">{prop.lang === 'en' ? 'Research Fund Name ':'ชื่อทุนวิจัย '} : {prop.lang === 'en' ? detail?.scholarship.title_en : detail?.scholarship.title}</h3>

                                <h3 className="title-bar mt-4 mb-2">{prop.lang === 'en' ? 'Part 5 Output/Result/Impact':'ส่วนที่ 5 ผลผลิต/ผลลัพธ์/ผลกระทบ'}</h3>
                                <h4 className="title-line-left mb-2">1. {prop.lang === 'en' ? 'Expected benefits':'ประโยชน์ที่คาดว่าจะได้รับ'}</h4>
                                <div className="row g-4">
                                    <div className="col-12">
                                        <div className="form-group">
                                            <div className="row ps-3">
                                                <div className="col-md-12">
                                                    <div className="form-check lg">
                                                        <input className="form-check-input" type="radio" value="" id="projectTypeId1" name="benefitId1" onChange={e => setBenefitId(Utils.PROPOSAL_OUTPUT_ACADEMIC)} checked={Utils.PROPOSAL_OUTPUT_ACADEMIC === benefitId} disabled={readOnly} />
                                                        <label className="form-check-label" htmlFor="benefitId1">{prop.lang === 'en' ? 'Academic':'ด้านวิชาการ'}</label>
                                                    </div>
                                                </div>
                                                <div className="col-md-12 mt-3">
                                                    <div className="form-check lg">
                                                        <input className="form-check-input" type="radio" value="" id="projectTypeId1" name="benefitId2" onChange={e => setBenefitId(Utils.PROPOSAL_OUTPUT_SOCIAL)} checked={Utils.PROPOSAL_OUTPUT_SOCIAL === benefitId} disabled={readOnly} />
                                                        <label className="form-check-label" htmlFor="benefitId2">{prop.lang === 'en' ? 'Social':'ด้านสังคม'}</label>
                                                    </div>
                                                    {
                                                        benefitId === Utils.PROPOSAL_OUTPUT_SOCIAL ? <div className="row mt-1 ps-5">
                                                            <div className="col-md-4">
                                                                <div className="form-check lg">
                                                                    <input className="form-check-input" type="radio" value="" id="benefitSubId1" name="benefitSubId1" onChange={e => setBenefitSubId(Utils.PROPOSAL_OUTPUT_SUB_PUBLIC)} checked={Utils.PROPOSAL_OUTPUT_SUB_PUBLIC === benefitSubId} disabled={readOnly} />
                                                                    <label className="form-check-label" htmlFor="benefitSubId1">{prop.lang === 'en' ? 'Public':'ด้านสาธารณะ'}</label>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-4">
                                                                <div className="form-check lg">
                                                                    <input className="form-check-input" type="radio" value="" id="benefitSubId2" name="benefitSubId2" onChange={e => setBenefitSubId(Utils.PROPOSAL_OUTPUT_SUB_COMMUNITY)} checked={Utils.PROPOSAL_OUTPUT_SUB_COMMUNITY === benefitSubId} disabled={readOnly} />
                                                                    <label className="form-check-label" htmlFor="benefitSubId2">{prop.lang === 'en' ? 'Community and area':'ด้านชุมชนและพื้นที่'}</label>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-4">
                                                                <div className="form-check lg">
                                                                    <input className="form-check-input" type="radio" value="" id="benefitSubId3" name="benefitSubId3" onChange={e => setBenefitSubId(Utils.PROPOSAL_OUTPUT_SUB_ENVIRONMENTAL)} checked={Utils.PROPOSAL_OUTPUT_SUB_ENVIRONMENTAL === benefitSubId} disabled={readOnly} />
                                                                    <label className="form-check-label" htmlFor="benefitSubId3">{prop.lang === 'en' ? 'Environmental':'ด้านสิ่งแวดล้อม'}</label>
                                                                </div>
                                                            </div>
                                                        </div> : ''
                                                    }
                                                </div>
                                                <div className="col-md-12 mt-3">
                                                    <div className="form-check lg">
                                                        <input className="form-check-input" type="radio" value="" id="projectTypeId1" name="benefitId3" onChange={e => setBenefitId(Utils.PROPOSAL_OUTPUT_POLICY)} checked={Utils.PROPOSAL_OUTPUT_POLICY === benefitId} disabled={readOnly} />
                                                        <label className="form-check-label" htmlFor="benefitId3">{prop.lang === 'en' ? 'Policy':'ด้านนโยบาย'}</label>
                                                    </div>
                                                </div>
                                                <div className="col-md-12 mt-3">
                                                    <div className="form-check lg">
                                                        <input className="form-check-input" type="radio" value="" id="projectTypeId1" name="benefitId4" onChange={e => setBenefitId(Utils.PROPOSAL_OUTPUT_ECONOMIC)} checked={Utils.PROPOSAL_OUTPUT_ECONOMIC === benefitId} disabled={readOnly} />
                                                        <label className="form-check-label" htmlFor="benefitId4">{prop.lang === 'en' ? 'Economic':'ด้านเศรษฐกิจ'}</label>
                                                    </div>
                                                </div>

                                                <div className="mt-3 ps-3">
                                                    <h6>{prop.lang === 'en' ? 'Detail':'ระบุรายละเอียด'}</h6>
                                                    <input type="text" className="form-control" ref={refBenefitDetail} maxLength={250} disabled={readOnly} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <h4 className="title-line-left mt-5 mb-3">2. {prop.lang === 'en' ? 'Beneficiaries of the project':'ผู้ได้รับประโยชน์จากโครงการ'}</h4>
                                <div className="row g-4">
                                    <div className="col-12">
                                        <div className="form-group">
                                            <textarea className="form-control" ref={refBeneficiary} maxLength={1000} rows={5} disabled={readOnly}></textarea>
                                        </div>
                                    </div>
                                </div>

                                <h4 className="title-line-left mt-5 mb-3">3. {prop.lang === 'en' ? 'Target groups':'กลุ่มเป้าหมายที่นำผลงาน สกมช. ไปใช้ และจำนวนของกลุ่มเป้าหมาย'}</h4>
                                <div className="row g-4 mb-3">
                                    <div className="col-12">
                                        {
                                            prop.lang === 'en' ? 'Users; Those who drive the work of R&D from researchers, research units or PMUs to create benefits, but may not be the ones who benefit from the work, such as government agencies whose duty is to drive knowledge to create benefits for communities, local areas or private sectors that receive R&D work to implement': 'Users; ผู้นำผลงาน ววน. จากนักวิจัย หน่วยวิจัยหรือ PMU ไปขับเคลื่อนให้เกิดประโยชน์ โดยอาจจะไม่ใช่ผู้ที่ได้รับประโยชน์จากผลงานนั้นๆ เช่น หน่วยงานภาครัฐที่มีหน้าที่นำความรู้ไปขับเคลื่อนให้เกิดประโยชน์ต่อชุมชน ท้องถิ่น หรือภาคเอกชนที่รับผลงาน ววน. ไปดำเนินการ)'
                                        }
                                    </div>
                                </div>
                                <ProposalTargetUser proposalId={proposalId} member={member} readOnly={readOnly} />

                                <h4 className="title-line-left mt-5 mb-3">4. {prop.lang === 'en' ? 'Target groups that will benefit and the number of target groups':'กลุ่มเป้าหมายที่จะได้รับประโยชน์และจำนวนของกลุ่มเป้าหมาย'}</h4>

                                <div className="row g-4 mb-3">
                                    <div className="col-12">
                                        {
                                            prop.lang === 'en' ? 'Beneficiaries; The ultimate beneficiaries of the research results that occur, who may not be the ones who directly use the research results, but who benefit from the results':'Beneficiaries; ผู้ได้รับประโยชน์สุดท้ายจากผลงาน ววน. ที่เกิดขึ้น โดยอาจจะไม่ใช่ผู้นำผลงานวิจัยไปใช้ประโยชน์โดยตรง แต่เป็นผู้ที่ได้รับประโยชน์จากผลงานดังกล่าว'
                                        }
                                    </div>
                                </div>
                                <ProposalTargetBenefit proposalId={proposalId} member={member} readOnly={readOnly} />

                                <h4 className="title-line-left mt-5 mb-3">5. {prop.lang === 'en' ? 'Output':'ผลผลิตที่คาดว่าจะได้รับ (Output)'}</h4>
                                <ProposalExpect proposalId={proposalId} member={member} readOnly={readOnly} />

                                <h4 className="title-line-left mt-5 mb-3">6. {prop.lang === 'en' ? 'Process information on how to turn research and innovation project outputs into expected outcomes':'ข้อมูลกระบวนการนำผลผลิตของโครงการวิจัยและนวัตกรรมไปสู่การสร้างผลลัพธ์ที่คาดว่าจะเกิดขึ้น'}</h4>
                                <div className="row g-4 mb-3">
                                    <div className="col-12">
                                        {
                                            prop.lang === 'en' ? 'The definition of the outcome is the result that occurs after the product of the project has been developed and the product has been utilized by a clear user, resulting in the level of knowledge, attitude, behavior, practice, or skills of the user or beneficiary changing from the original when compared to no research results, as well as other benefits that occur to the target group or target area, including the utilization of the product of the project, which is a product, service, and technology, by the private sector or civil society, as well as the further development of the product of the original project that is not yet complete, to have a significantly higher level of readiness for use.': <><b>นิยามของผลลัพธ์</b> คือ ผลที่เกิดขึ้นหลังจากมีผลผลิตของโครงการ ววน. และผลผลิตนั้นถูกนำไปใช้ประโยชน์ โดยผู้ใช้ (Users) ที่ชัดเจน ส่งผลทําให้ระดับความรู้ ทัศนคติ พฤติกรรม การปฏิบัติ หรือทักษะของผู้ใช้หรือผู้ได้รับประโยชน์มีการเปลี่ยนแปลงไปจากเดิมเมื่อเทียบกับ ไม่มีผลงานวิจัย อีกทั้งประโยชน์อื่นที่เกิดขึ้น           กับกลุ่มเป้าหมายหรือพื้นที่เป้าหมาย รวมถึงการใช้ประโยชน์จากผลผลิตของโครงการที่เป็นทั้งผลิตภัณฑ์ การบริการ และเทคโนโลยี โดยภาคเอกชนหรือประชาสังคม ตลอดจนการพัฒนาต่อยอดผลผลิตของโครงการเดิมที่ยังไม่เสร็จสมบูรณ์ ให้มี ระดับความพร้อมในการใช้ประโยชน์สูงขึ้นอย่างมีนัยสําคัญ</>
                                        }
                                    </div>
                                </div>
                                <ProposalProcess proposalId={proposalId} member={member} readOnly={readOnly} />

                                <h4 className="title-line-left mt-5 mb-3">7. {prop.lang === 'en' ? 'Expected Impacts':'ผลกระทบ (Expected Impacts) ที่คาดว่าจะเกิดขึ้น'}</h4>
                                <div className="row g-4 mb-3">
                                    <div className="col-12">
                                        {
                                            prop.lang === 'en' ? 'The definition of impact is a change resulting from a broad range of outcomes in academic, policy, economic, social and environmental aspects, or a long-term success that results from a change in an outcome through engagement activities and an impact pathway to drive the creation of impact. The impact that occurs will include both positive and negative impacts, direct and indirect, both intended and unintended.': <><b>นิยามของผลกระทบ</b> คือ การเปลี่ยนแปลงที่เกิดขึ้นจากผลลัพธ์ (outcome) ในวงกว้างทั้งด้านวิชาการ นโยบาย เศรษฐกิจ สังคมและสิ่งแวดล้อม หรือผลสำเร็จระยะยาวที่เกิดขึ้นต่อเนื่องจากการเปลี่ยนแปลง ของผลลัพธ์ โดยผ่านกระบวนการการสร้างการมีส่วนร่วม (Engagement activities) และมีเส้นทาง ของผลกระทบ (impact pathway) ในการขับเคลื่อนไปสู่การสร้างผลกระทบ ทั้งนี้ ผลกระทบที่เกิดขึ้น จะพิจารณารวมผลกระทบในเชิงบวกและเชิงลบ ทางตรงและทางอ้อม ทั้งที่ตั้งใจและไม่ตั้งใจให้เกิดขึ้น</>
                                        }
                                    </div>
                                </div>
                                <ProposalImpact proposalId={proposalId} member={member} readOnly={readOnly} />

                                <div className="py-3"><hr /></div>
                                <div className="buttons gap-15 py-0 mb-4">
                                    <button className="btn btn-gray w-130" type="button" onClick={onCancel}>{prop.lang === 'en' ? 'Prev':'ย้อนกลับ'}</button>
                                    {
                                        !readOnly ? <button className="btn btn-secondary w-130" type="button" onClick={onSubmit}>{prop.lang === 'en' ? 'Save':'บันทึกข้อมูล'}</button> : ''
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Toaster position="top-right" />
        </>
    );
} 